module.exports = __webpack_public_path__ + "assets/img/u338.7ee86542.svg";